export interface QuestStep {
  id: string;
  title: string;
  description: string;
  targetCount: number;
  currentCount: number;
  completed: boolean;
}

export const INITIAL_QUEST_STEPS: readonly Omit<QuestStep, 'currentCount' | 'completed'>[] = [
  {
    id: 'quest_move',
    title: 'Awakened Slime',
    description: 'Explore the primordial grove using WASD and hop with Space.',
    targetCount: 10
  },
  {
    id: 'quest_absorb',
    title: 'Insatiable Gluttony',
    description: 'Dissolve and absorb 3 natural resources (Herbs or Rocks) with E.',
    targetCount: 3
  },
  {
    id: 'quest_mutate',
    title: 'Evolutionary Leap',
    description: 'Unlock your first cellular mutation in the Mutations panel.',
    targetCount: 1
  },
  {
    id: 'quest_settle',
    title: "Pioneer's Haven",
    description: 'Construct a Campfire structure to establish your settlement.',
    targetCount: 1
  },
  {
    id: 'quest_tame',
    title: 'Familiar Companion',
    description: 'Befriend a wild Horned Forest Bunny with gentle companionship.',
    targetCount: 1
  },
  {
    id: 'quest_boss',
    title: 'Trial of the Titan',
    description: 'Venture into the Runed Arena and vanquish the Crystal Golem!',
    targetCount: 1
  }
];
